import { closeModal, selectModalState } from "src/store/slices/modalSlice";
import { useSelector } from "react-redux";
import { AddAccountModal } from "./AddAccountModal";
import { AddCompanyModal } from "./AddCompanyModal";
import { AddNewClient } from "./AddNewClient";
import { RootState } from "src/store/store";
import { AddClient } from "./AddClient";
import { SidebarClient } from "./SidebarClient";
import { CreateRuleModal } from "../CreateRuleModal";
import { EditClientModal } from "./EditClient/index";
import { EditCompanyModal } from "./EditCompanyModal";
import { EditAccountModal } from "./EditAccountModal";
import { useAppDispatch } from "src/store/hooks";
import { fetchClientAccounts } from "src/store/slices/clientDetailSlice";
import { BalanceSnapshotsModal } from "./BalanceSnapshotsModal";
import { CompanyEquityModal } from "./CompanyEquityModal";
import { useBodyScrollLock } from "src/hooks/useBodyScrollLock";

type ModalItem = {
  name: string;
  component: React.ComponentType<any>;
};

const modalsList: ModalItem[] = [
  {
    name: "addAccountModal",
    component: AddAccountModal,
  },
  {
    name: "addCompanyModal",
    component: AddCompanyModal,
  },
  {
    name: "addNewClient",
    component: AddNewClient,
  },
  {
    name: "addClient",
    component: AddClient,
  },
  {
    name: "sidebarClient",
    component: SidebarClient,
  },
  {
    name: "createRuleModal",
    component: CreateRuleModal,
  },
  {
    name: "editClientModal",
    component: EditClientModal,
  },
  {
    name: "editCompanyModal",
    component: EditCompanyModal,
  },
  {
    name: "editAccountModal",
    component: EditAccountModal,
  },
  {
    name: "balanceSnapshotsModal",
    component: BalanceSnapshotsModal,
  },
  {
    name: "companyEquityModal",
    component: CompanyEquityModal,
  },
];

const Modal = () => {
  const dispatch = useAppDispatch();
  const modals = useSelector((state: RootState) => selectModalState(state));
  const currentList = modalsList.filter((el) => modals.types.includes(el.name));
  useBodyScrollLock(currentList.length > 0);

  const getModalProps = (modalName: string) => {
    switch (modalName) {
      case "addAccountModal": {
        const modalData = (modals.data as any)?.addAccountModal;
        const clientId = modalData?.clientId as number | undefined;
        return {
          clientId,
          onClose: () => {
            dispatch(closeModal({ type: "addAccountModal" }));
            if (clientId) {
              dispatch(fetchClientAccounts({ client_id: clientId }));
            }
            window.dispatchEvent(new CustomEvent("accountUpdated"));
          },
        };
      }
      case "createRuleModal":
        return {
          onClose: () => dispatch(closeModal({ type: "createRuleModal" })),
          onSuccess: () => {
            dispatch(closeModal({ type: "createRuleModal" }));
            window.dispatchEvent(new CustomEvent("ruleCreated"));
          },
        };
      default:
        return {};
    }
  };

  return (
    <>
      {currentList.map((el) => {
        const Component = el.component;
        const modalProps = getModalProps(el.name);
        return <Component key={el.name} {...modalProps} />;
      })}
    </>
  );
};

export default Modal;
